import { cn } from '@sparklayer-io/spark-dash-ui/lib/styles';

const SIZE_CLASSES = {
  sm: 'size-8',
  md: 'size-10',
  lg: 'size-28',
} as const;

type ProductImageSize = keyof typeof SIZE_CLASSES;

type ProductImageProps = {
  src: string;
  size: ProductImageSize;
  /** Labels the image for assistive tech. Omit where the image only repeats adjacent text. */
  label?: string;
  emptyLabel?: string;
};

// A product or variant image with a placeholder tile for the products that have none.
export function ProductImage({ src, size, label, emptyLabel }: ProductImageProps) {
  const shape = cn('aspect-square rounded', SIZE_CLASSES[size]);

  if (!src) {
    const placeholder = cn(shape, 'bg-platform-primary/10');
    // Split rather than a conditional role, an unlabelled img role announces nothing useful.
    return emptyLabel ? (
      <div role="img" aria-label={emptyLabel} className={placeholder} />
    ) : (
      <div aria-hidden="true" className={placeholder} />
    );
  }

  return <img src={src} alt="" aria-label={label} className={shape} />;
}
